import type { AxiosInstance } from 'axios';

export interface SupportRequest {
  category: string;
  subject: string;
  description: string;
  planName?: string;
  subscriptionStatus?: string;
}

export interface SupportResponse {
  notified: boolean;
}

export const SupportService = (api: AxiosInstance) => ({
  submitRequest: async (request: SupportRequest): Promise<SupportResponse> => {
    const response = await api.post<SupportResponse>('/support', request);
    return response.data;
  },
});
